import {
  Box,
  HStack,
  Avatar,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Student } from "../../../services/Dtos";
import useThemeColors from "../../../hooks/useThemeColors";
import { getInitials } from "../../../services/Utils";

interface Props {
  onClickStudent: (student: Student) => void;
  students: (Student)[];
  classMap: { [key: string]: string };
}

export default function RecentStudentTable({
  onClickStudent,
  students,
  classMap,
}: Props) {
  const colors = useThemeColors();

  return (
    <VStack gap={3} align="stretch" w={"full"} pt={3}>
      {students.slice(0, 5).map((student) => (
        <Box
          key={student.id}
          p={4}
          borderRadius="lg"
          bg={colors.background.subtle}
          border="1px solid"
          borderColor={colors.border.subtle + "/30"}
          cursor="pointer"
          transition="all 0.2s ease"
          _hover={{
            transform: "translateY(-2px)",
            boxShadow: colors.shadow.cardHover,
            bg: colors.schoolAccent.hover,
            borderColor: colors.border.subtle,
          }}
          _active={{
            transform: "translateY(0px)",
          }}
          onClick={() => onClickStudent(student)}
        >
          <HStack gap={4} align="flex-start">
            <Avatar.Root colorPalette="red" size="md">
              <Avatar.Image src={student.avatarUrl} />
              <Avatar.Fallback
                name={getInitials(
                  `${student.firstName} ${student.middleName} ${student.lastName}`
                )}
              />
            </Avatar.Root>

            <VStack align="flex-start" gap={1} flex={1}>
              <Text
                fontWeight="medium"
                color={colors.text.primary}
                fontSize="sm"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                maxW="100%"
              >
                {student.firstName} {student.middleName} {student.lastName}
              </Text>
              <Text fontSize="xs" color={colors.text.secondary} opacity={0.8}>
                {classMap[student.currentClassId]}
              </Text>
            </VStack>
          </HStack>
        </Box>
      ))}
    </VStack>
  );
}
